import styled from 'styled-components';

export const WidgetActions = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 8px;
`;
